import React, { useEffect, useState } from "react";
import { Bars } from "react-loader-spinner";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axiosInstance from "../../../Shared/axiosInstance.js";

export default function BrandProducts() {
  const { id } = useParams();
  const [products, setProducts] = useState(null);
  const [load, setLoad] = useState(false);

  // جلب المنتجات حسب العلامة التجارية
  async function getProductsByBrand() {
    setLoad(true);
    try {
      const { data } = await axiosInstance.get(`/Product/Brand/${id}`);
      setProducts(data?.data);
    } catch (error) {
      console.error("خطأ عند جلب المنتجات حسب العلامة التجارية:", error);
      Swal.fire({
        title: "خطأ!",
        text: error.response?.data?.message || "فشل في جلب المنتجات.",
        icon: "error",
      });
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    getProductsByBrand();
  }, [id]);

  // Loader
  if (load) {
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center flex-column">
        <Bars height="80" width="80" color="#2563eb" ariaLabel="loading" />
        <p className="mt-3" style={{ color: "#64748b", fontSize: "18px" }}>
          جاري تحميل المنتجات...
        </p>
      </div>
    );
  }

  // حالة عدم وجود منتجات
  if (!products || products.length === 0) {
    return (
      <div className="vh-100 d-flex align-items-center justify-content-center flex-column">
        <h3 style={{ color: "#64748b" }}>لا توجد منتجات لهذه العلامة التجارية</h3>
      </div>
    );
  }

  return (
    <div className="container py-5 mt-5" style={{ maxWidth: "1000px" }}>
      <h2 className="text-center mb-4 mt-5 pt-5" style={{ color: "#2563eb", fontWeight: 700 }}>
        المنتجات الخاصة بهذه العلامة التجارية
      </h2>

      <div className="table-responsive">
        <table
          className="table mb-0"
          style={{
            border: "1px solid #dbeafe",
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(37, 99, 235, 0.15)",
            textAlign: "center",
          }}
        >
          <thead style={{ background: "#dbeafe" }}>
            <tr>
              {["#", "الاسم", "الوصف", "سعر البيع (EGP)", "سعر الشراء (EGP)", "الكمية", "العلامة التجارية"].map(
                (th, idx) => (
                  <th key={idx} style={thStyle}>{th}</th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {products.map((prod, index) => (
              <tr key={prod.id} style={{ background: index % 2 === 0 ? "#f8fafc" : "#ffffff" }}>
                <td style={tdStyle}>{index + 1}</td>
                <td style={{ ...tdStyle, fontWeight: 600 }}>{prod.name}</td>
                <td style={tdStyle}>{prod.description || "-"}</td>
                <td style={{ ...tdStyle, color: "#22c55e", fontWeight: 600 }}>{prod.sellPrice}</td>
                <td style={{ ...tdStyle, color: "#2563eb" }}>{prod.buyPrice}</td>
                <td style={{ ...tdStyle, color: "#dc2626", fontWeight: 600 }}>{prod.quantityInStock}</td>
                <td style={tdStyle}>{prod.brandName || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// Styles
const thStyle = {
  color: "#1e40af",
  fontSize: "15px",
  padding: "12px",
  fontWeight: 600,
  border: "1px solid #bfdbfe",
};

const tdStyle = {
  padding: "12px",
  border: "1px solid #e0e7ff",
  fontSize: "16px",
  color: "#475569",
};
